export function debounce<T extends (...args: unknown[]) => unknown>(
  func: T,
  wait: number,
): (...args: Parameters<T>) => Promise<ReturnType<T>> {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  let resolveList: Array<(value: unknown) => void> = [];

  return function (this: unknown, ...args: Parameters<T>) {
    if (timeout) clearTimeout(timeout);

    return new Promise<ReturnType<T>>((resolve) => {
      resolveList.push(resolve as (value: unknown) => void);

      timeout = setTimeout(async () => {
        timeout = null;
        try {
          const result = await func.apply(this, args);
          resolveList.forEach((r) => r(result));
        } catch (err) {
          resolveList.forEach((r) => r(Promise.reject(err)));
        } finally {
          resolveList = [];
        }
      }, wait);
    });
  };
}
